var render = function render(){var _vm=this,_c=_vm._self._c;return _c('goods-selector',{model:{value:(_vm.$$FormData[_vm.config.__key]),callback:function ($$v) {_vm.$set(_vm.$$FormData, _vm.config.__key, $$v)},expression:"$$FormData[config.__key]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }